export const displayCriteriaFields = {
  orderNetValue: 'order_net_value',
}

export const netOrderAmountTypeByMatchType = {
  greater_than: 'greater_than',
  lower_than: 'less_than',
}
